// extracted by mini-css-extract-plugin
export default {"tooltip":"Person_tooltip__NHjSi","verticalAlign":"Person_verticalAlign__1X2wt","personImg":"Person_personImg__wWtiO"};